import React from 'react';
export function FooterSection() {
  return <footer className="bg-brand-dark border-t border-brand-gold/10" data-id="element-97">
      <div className="max-w-4xl mx-auto px-6 py-12 text-center" data-id="element-98">
        <p className="font-heading text-lg md:text-xl text-brand-ivory/70 italic leading-relaxed max-w-2xl mx-auto" data-id="element-99">
          "Llevas tiempo buscando el sistema que lo integre todo. Hoy lo
          encontraste. La única pregunta es si vas a hacer algo al respecto."
        </p>

        <div className="h-px w-16 bg-brand-gold/30 mx-auto my-8" data-id="element-100" />

        <p className="text-brand-muted-dark font-body text-sm" data-id="element-101">
          © Protocolo 24H: Salto Cuántico — Todos los derechos reservados
        </p>
        <p className="text-brand-muted-dark font-body text-xs mt-2" data-id="element-102">
          Producto de carácter educativo e informativo. Los resultados
          individuales pueden variar.
        </p>
      </div>
    </footer>;
}